export default __webpack_public_path__ + "static/8-57fe07ef8259730e1296312dff429e6d.jpg";